/// <amd-module name="Artifacts/Npm/commands/Delete" />
import { NpmActions } from "Artifacts/Npm/redux";
import { getDeleteCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createDeleteCommand = getDeleteCommandCreator(NpmActions.softDelete);
